import React from "react";
import SEO_1 from "../images/SEO_1";

export default function SEO() {
  return (
    <>
      <section>
        <div className="container-fluid">
          <img src={SEO_1} alt="" />
        </div>
      </section>
      <div id="content" class="site-content">
        <div class="ast-container">
          <div
            data-elementor-type="wp-page"
            data-elementor-id="570"
            class="elementor elementor-570"
            data-elementor-settings="[]"
          >
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-a1c2e5a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="a1c2e5a"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3a61ef8"
                        data-id="3a61ef8"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-7339e46 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="7339e46"
                  data-element_type="section"
                >
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-de35394"
                        data-id="de35394"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-885ad9d elementor-widget elementor-widget-image"
                              data-id="885ad9d"
                              data-element_type="widget"
                              data-widget_type="image.default"
                            >
                              <div class="elementor-widget-container">
                                <div class="elementor-image">
                                  <img
                                    width="270"
                                    height="283"
                                    src="https://thumbs.dreamstime.com/b/seo-search-engine-optimization-marketing-ranking-traffic-website-internet-business-technology-concept-105032541.jpg"
                                    class="attachment-large"
                                    alt=""
                                    loading="lazy"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-be51d22"
                        data-id="be51d22"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-4f158cf elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                              data-id="4f158cf"
                              data-element_type="widget"
                              data-widget_type="divider.default"
                            >
                              <div class="elementor-widget-container">
                                <div class="elementor-divider">
                                  <span class="elementor-divider-separator"></span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-004e729 elementor-widget elementor-widget-heading"
                              data-id="004e729"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">
                                  SEO pulls-in quality traffic
                                </h2>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-678fe09 elementor-widget elementor-widget-text-editor"
                              data-id="678fe09"
                              data-element_type="widget"
                              data-widget_type="text-editor.default"
                            >
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    Traffic on search engines is the best
                                    traffic. Why? Because people are actually
                                    searching for the problem you solve. Top
                                    Notch Media Works can “pull” traffic to your
                                    business website or bogs. Search traffic is
                                    already interested in your products and
                                    services.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-47dee95 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="47dee95"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-0c6c6b8"
                        data-id="0c6c6b8"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-9e4f930 elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                              data-id="9e4f930"
                              data-element_type="widget"
                              data-widget_type="divider.default"
                            >
                              <div class="elementor-widget-container">
                                <div class="elementor-divider">
                                  <span class="elementor-divider-separator"></span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-cf095b6 elementor-widget elementor-widget-heading"
                              data-id="cf095b6"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">
                                  There are people searching for your products
                                  or services on search engines
                                </h2>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-de7b06f elementor-widget elementor-widget-text-editor"
                              data-id="de7b06f"
                              data-element_type="widget"
                              data-widget_type="text-editor.default"
                            >
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    There are over 2 billion people online. 93%
                                    of online activities start on a search
                                    engine. There are 40,000 searches every
                                    second, and 3.5 billion searches per day.
                                    There are millions of opportunities for your
                                    business to become found on search engines.
                                    One of the most important benefits of SEO is
                                    that your customers are using search engines
                                    daily. Top Notch
                                    <br />
                                    Media Works Make it simple for you and your
                                    business.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-f89ed36"
                        data-id="f89ed36"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-1f4e0eb elementor-widget elementor-widget-image"
                              data-id="1f4e0eb"
                              data-element_type="widget"
                              data-widget_type="image.default"
                            >
                              <div class="elementor-widget-container">
                                <div class="elementor-image">
                                  <img
                                    width="719"
                                    height="522"
                                    src="https://sirv.sirv.com/blog/image%20seo/2456071.png"
                                    class="attachment-large"
                                    alt=""
                                    loading="lazy"
                                    srcset="https://sirv.sirv.com/blog/image%20seo/2456071.png"
                                    sizes="(max-width: 719px) 100vw, 719px"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="mt-3 elementor-section elementor-top-section elementor-element elementor-element-de9f788 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="de9f788"
                  data-element_type="section"
                >
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-8210607"
                        data-id="8210607"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-f21279a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="f21279a"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-1e00d69"
                                    data-id="1e00d69"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-09c919d elementor-widget elementor-widget-image"
                                          data-id="09c919d"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                                src="https://t3.ftcdn.net/jpg/02/16/51/16/240_F_216511666_y3RnXLRGAtEu2XpeiYR7ldkuK3rdzMUn.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-bf7b80a"
                                    data-id="bf7b80a"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-cc40245 elementor-widget elementor-widget-heading"
                                          data-id="cc40245"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              SEO traffic is more likely to
                                              convert
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-5a4415f elementor-widget elementor-widget-text-editor"
                                          data-id="5a4415f"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                SEO traffic is more likely to
                                                convert than other sources of
                                                traffic. In fact, search traffic
                                                has the best conversion rates
                                                for most websites. By
                                                positioning yourself on search
                                                engines, Top Notch Media Works
                                                will help you to positioning
                                                your business to win more
                                                conversions.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a3dc17f"
                        data-id="a3dc17f"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-dd87356 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="dd87356"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-117463d"
                                    data-id="117463d"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-38185de elementor-widget elementor-widget-image"
                                          data-id="38185de"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                               
                                                src="https://t4.ftcdn.net/jpg/01/20/33/19/240_F_120331912_dGahf9iKQ11Daib9QXxehqVThrrQYtT1.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-8812834"
                                    data-id="8812834"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-3c38f11 elementor-widget elementor-widget-heading"
                                          data-id="3c38f11"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              SEO increases sales and leads
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-bf90b81 elementor-widget elementor-widget-text-editor"
                                          data-id="bf90b81"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                SEO is not a myth. Top Notch
                                                Media Works will increase your
                                                leads and sales if you offer a
                                                viable product or service. One
                                                small business generates lead
                                                and sales beond expectations in
                                                just 5 months. However, you must
                                                invest in the best SEO strategy,
                                                your business will be on it’s
                                                way to higher conversions.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-91a2e5a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="91a2e5a"
                  data-element_type="section"
                >
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-122f3b2"
                        data-id="122f3b2"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-c909709 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="c909709"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-fbedb24"
                                    data-id="fbedb24"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-1bbeb05 elementor-widget elementor-widget-image"
                                          data-id="1bbeb05"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                               
                                                src="https://as2.ftcdn.net/v2/jpg/03/60/06/35/1000_F_360063577_kbTdas65GnCwfRizP3ETNTkoe0derfGR.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-baa7d4b"
                                    data-id="baa7d4b"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-c4a952c elementor-widget elementor-widget-heading"
                                          data-id="c4a952c"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              Top Notch Media Works provides
                                              24/7 promotion
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-eae0412 elementor-widget elementor-widget-text-editor"
                                          data-id="eae0412"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                SEO is 24/7. It does not sleep.
                                                Your rankings do not disappear
                                                overnight. You can increase your
                                                website traffic all day, every
                                                day. Once you rank high in
                                                search engines, Top Notch Media
                                                Works will promote your business
                                                while you are sleeping.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a5eb2d1"
                        data-id="a5eb2d1"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-daf89b2 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="daf89b2"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-de52c34"
                                    data-id="de52c34"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-72815ae elementor-widget elementor-widget-image"
                                          data-id="72815ae"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                               
                                                src="https://t3.ftcdn.net/jpg/01/09/17/50/240_F_109175025_wAZVzh1os4PF3iMBoShlSH1jj6Z9cIyO.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-8ed2584"
                                    data-id="8ed2584"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-deccc84 elementor-widget elementor-widget-heading"
                                          data-id="deccc84"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              SEO builds trust and credibility
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-4eb18c3 elementor-widget elementor-widget-text-editor"
                                          data-id="4eb18c3"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                People trust Google. They use it
                                                every day to find what they are
                                                looking for. By ranking high on
                                                search engines, your business
                                                will build trust and credibility
                                                with your audience. In fact, 37%
                                                of search engine clicks are on
                                                the first organic listing. Top
                                                Notch Media Works provide you
                                                this convenience.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-0e09af9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="0e09af9"
                  data-element_type="section"
                >
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-f0f4035"
                        data-id="f0f4035"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-9f5f20c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="9f5f20c"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-0dd9d6c"
                                    data-id="0dd9d6c"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-5bee659 elementor-widget elementor-widget-image"
                                          data-id="5bee659"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                               
                                                src="https://t4.ftcdn.net/jpg/04/24/00/77/240_F_424007720_U4HM19EY0cuNHB4gmRUkdO2b3axNCvGX.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-782a9a5"
                                    data-id="782a9a5"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-a4bd690 elementor-widget elementor-widget-heading"
                                          data-id="a4bd690"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              SEO makes your customers more
                                              informed
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-4cdbb92 elementor-widget elementor-widget-text-editor"
                                          data-id="4cdbb92"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                Your customers are using search
                                                engines to research. They use
                                                their findings to help them make
                                                informed decisions on available
                                                options. High SEO rankings
                                                allows you to educate potential
                                                customers. This indirectly
                                                builds trust, but most
                                                importantly helps them make an
                                                informed decision.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2af7f38"
                        data-id="2af7f38"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-68559a1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="68559a1"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-c1633b0"
                                    data-id="c1633b0"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-f354eeb elementor-widget elementor-widget-image"
                                          data-id="f354eeb"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                               
                                                src="https://t3.ftcdn.net/jpg/05/51/11/60/240_F_551116030_I6u3IFcibTRTNyLpZ6XtJUv2Z8Zh2Nkz.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-750f9c8"
                                    data-id="750f9c8"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-093c4b1 elementor-widget elementor-widget-heading"
                                          data-id="093c4b1"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              SEO influences purchasing
                                              decisions
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-6fbfa82 elementor-widget elementor-widget-text-editor"
                                          data-id="6fbfa82"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                SEO significantly influences
                                                purchasing decisions. This is
                                                because of the developed trust
                                                and credibility mentioned in our
                                                prior points. Use SEO to improve
                                                your conversions by
                                                significantly influencing the
                                                purchasing decisions of those on
                                                the web.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-318c881 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="318c881"
                  data-element_type="section"
                >
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6642284"
                        data-id="6642284"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-f1a2734 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="f1a2734"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-5b534d9"
                                    data-id="5b534d9"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-0b75094 elementor-widget elementor-widget-image"
                                          data-id="0b75094"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                                // width="100"
                                                // height="100"
                                                src="https://t3.ftcdn.net/jpg/05/51/11/26/240_F_551112699_vglAgtEOvJdSiKtQvmXkMRF6822JwEsZ.jpg"
                                                class="attachment-thumbnail size-thumbnail"
                                                alt="seo, web page, web design"
                                                loading="lazy"
                                                srcset="https://t3.ftcdn.net/jpg/05/51/11/26/240_F_551112699_vglAgtEOvJdSiKtQvmXkMRF6822JwEsZ.jpg"
                                                sizes="(max-width: 150px) 100vw, 150px"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-022440a"
                                    data-id="022440a"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-0b4e180 elementor-widget elementor-widget-heading"
                                          data-id="0b4e180"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              Your competitors are using SEO to
                                              grow
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-e86ba3c elementor-widget elementor-widget-text-editor"
                                          data-id="e86ba3c"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                Kill or be killed. Your
                                                customers start their internet
                                                journey with a search. Your
                                                competitors are using search to
                                                grow their business. Sooner or
                                                later, if you are not using
                                                search to grow your business,
                                                you will not have a business
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7f594f3"
                        data-id="7f594f3"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-149e2b0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="149e2b0"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-84452bd"
                                    data-id="84452bd"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-c4c43ea elementor-widget elementor-widget-image"
                                          data-id="c4c43ea"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                               
                                                src="https://t3.ftcdn.net/jpg/00/49/09/74/240_F_49097406_HXUmrooGymMMFvoDUiJfWA0VdsDTiRTq.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-bc4dda1"
                                    data-id="bc4dda1"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-5393ca6 elementor-widget elementor-widget-heading"
                                          data-id="5393ca6"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              SEO can give smaller businesses an
                                              edge on larger companies
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-3bf1c9a elementor-widget elementor-widget-text-editor"
                                          data-id="3bf1c9a"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                If you operate a small business,
                                                you may find that it is tough to
                                                outspend larger competitors in
                                                AdWords. However, an effective
                                                SEO strategy may be your way to
                                                gain higher rankings. While
                                                larger companies rely on
                                                advertising, you can rely on a
                                                savvy SEO strategy to go in the
                                                back door to acquire customers.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-ca7296b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="ca7296b"
                  data-element_type="section"
                >
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2b9c9a9"
                        data-id="2b9c9a9"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-74cdf32 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="74cdf32"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-44d9be3"
                                    data-id="44d9be3"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-7c95549 elementor-widget elementor-widget-image"
                                          data-id="7c95549"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                               
                                                src="https://t3.ftcdn.net/jpg/01/27/89/98/240_F_127899826_Wi93CggCZNwWtQ67c9drw058Q1NUmvv9.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-0254c07"
                                    data-id="0254c07"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-af7227a elementor-widget elementor-widget-heading"
                                          data-id="af7227a"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              SEO increases your brand awareness
                                              and equity
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-fc2414a elementor-widget elementor-widget-text-editor"
                                          data-id="fc2414a"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                SEO will also build your brand
                                                equity. In other words, SEO will
                                                help people become aware of your
                                                brand. Awareness is important
                                                because your website visitors
                                                may not always be ready to
                                                purchase. However, by being
                                                aware of your offerings, they
                                                may purchase in the near future.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-0ee714b"
                        data-id="0ee714b"
                        data-element_type="column"
                      >
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-9968aed elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="9968aed"
                              data-element_type="section"
                            >
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-cfc21eb"
                                    data-id="cfc21eb"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-5ba9e01 elementor-widget elementor-widget-image"
                                          data-id="5ba9e01"
                                          data-element_type="widget"
                                          data-widget_type="image.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img
                                               
                                                src="https://as2.ftcdn.net/v2/jpg/04/39/56/97/1000_F_439569708_yCkKLFOtRYBXWdsT0ix1A0ZLlRKBf59U.jpg"
                                                class="attachment-large size-large"
                                                alt=""
                                                loading="lazy"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-f7827ec"
                                    data-id="f7827ec"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-2a0a4b0 elementor-widget elementor-widget-heading"
                                          data-id="2a0a4b0"
                                          data-element_type="widget"
                                          data-widget_type="heading.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">
                                              SEO increases customer attribution
                                              or “touches”
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-93d5da9 elementor-widget elementor-widget-text-editor"
                                          data-id="93d5da9"
                                          data-element_type="widget"
                                          data-widget_type="text-editor.default"
                                        >
                                          <div class="elementor-widget-container">
                                            <div class="elementor-text-editor elementor-clearfix">
                                              <p>
                                                While your awareness is
                                                increasing, SEO will
                                                simultaneously increase your
                                                customer attribution points.
                                                Attribution is the amount of
                                                times your audience sees your
                                                brand. The more times they see
                                                your business, the more likely
                                                they are to purchase from your
                                                business. Strong SEO rankings
                                                will help you dramatically
                                                increase your touch points with
                                                potential buyers.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        {/* //  <!-- ast-container --> */}
      </div>
      {/* // <!-- #content --> */}
    </>
  );
}
